import { ApiArrayGetter, apiService } from "@/services/api/apiService";
import { enhanceObjectCopy, isNotNullObject } from "@/helpers/units";
import { IServicePatient } from "@/services/api/Service/patient";

class Rnumb {
  "rnumb_id" = 1050305590;
  "dat_bgn" = "09.08.2023 11:00";
  "dat_end" = "09.08.2023 12:00";
  "cab" = null;
  "spec" = "Неврология";
  "srv_text" = "1.Телемедицина/Онлайн-консультация";
  "doctor_id" = 1885827;
  "firstname" = "Владимир";
  "lastname" = "Палагин";
  "secondname" = "ДжейДинович";
  "depname" = "Медицинский центр";
  "addr" = "Санкт-Петербург, Измайловский проспект 29";
  "phone" = "+7(999)999-99-99";
  "paystatus" = 0;
  "calc_sum" = null;
  "is_telemed" = 1;
  "url_telemed" = null;
  "type_r" = "rnumb";
  "form_result_id" = 2005649411;
  "is_mandatory" = 0;
  "is_exists" = 0;
  "prot_status" = 0;

  constructor(rawData: Record<string, unknown> = {}) {
    enhanceObjectCopy(rawData, this as Record<string, unknown>);
  }
}

export type IRnumb = Rnumb;

export const API_Rnumb_list = ApiArrayGetter<unknown, IRnumb>(
  {
    endpoint: "/rnumb/list",
    method: "get",
  },
  Rnumb
);
